/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { FaceToFaceViewModel } from './FaceToFaceViewModel'; 

export function getFaceToFaceOptions(stayId: string, onSuccess?: (result: FaceToFaceViewModel) => void) {
	return queryOptions({
		queryKey: ['face-to-face', stayId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/billing/facetofaces/queries/getfacetoface/' + stayId;
			const resp = await axios.get<FaceToFaceViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(stayId)
	});
}